/** @jsxImportSource @emotion/react */
import React, { useContext } from 'react';
import { useFormik } from 'formik';
import { ThemeContext } from '../../config/theme';
import { prescriptionData } from '../../utils/types';
import themedStyles from './PrescriptionForm.css';

type Props = {
  onSubmitForm: (data: prescriptionData) => void;
  submittedPrescriptionData: prescriptionData | string;
};

const initialPrescription = {
  left_sphere: '',
  left_cylinder: '',
  left_axis: '',
  right_sphere: '',
  right_cylinder: '',
  right_axis: '',
  p_d: '',
};

export default function PrescriptionForm({ onSubmitForm, submittedPrescriptionData }: Props) {
  const formik = useFormik<prescriptionData>({
    initialValues: initialPrescription,
    onSubmit: onSubmitForm,
  });
  const disableButton = (data: prescriptionData): boolean => {
    return data === submittedPrescriptionData;
  };
  const hasPrescription = submittedPrescriptionData !== '';
  const styling = themedStyles(useContext(ThemeContext));
  return (
    <form onSubmit={formik.handleSubmit}>
      <div css={styling.container}>
        <div>
          <p className="type-heading-meta">venstre</p>
          <div css={styling.input}>
            <label htmlFor="customerLeftSphere">sphere</label>
            <input
              onChange={formik.handleChange}
              required
              type="number"
              name="left_sphere"
              value={formik.values.left_sphere}
              id="customerLeftSphere"
              className="product-form__option-select"
              step="0.25"
              pattern="^\d*\.?\d*((25)|(50)|(5)|(75)|(0)|(00))?$"
              min="-5"
              max="5"
            />
          </div>
          <div css={styling.input}>
            <label htmlFor="customerLeftCylinder">cylinder</label>
            <input
              onChange={formik.handleChange}
              required
              type="number"
              name="left_cylinder"
              value={formik.values.left_cylinder}
              id="customerLeftCylinder"
              className="product-form__option-select"
              step="0.25"
              pattern="^\d*\.?\d*((25)|(50)|(5)|(75)|(0)|(00))?$"
              min="-4"
              max="0"
            />
          </div>
          <div css={styling.input}>
            <label htmlFor="customerLeftAxis">axis</label>
            <input
              onChange={formik.handleChange}
              type="number"
              name="left_axis"
              value={formik.values.left_axis}
              id="customerLeftAxis"
              className="product-form__option-select"
              min="0"
              max="180"
            />
          </div>
        </div>

        <div>
          <p className="type-heading-meta">høyre</p>

          <div css={styling.input}>
            <label htmlFor="customerRightSphere">sphere</label>
            <input
              onChange={formik.handleChange}
              required
              type="number"
              name="right_sphere"
              value={formik.values.right_sphere}
              id="customerRightSphere"
              className="product-form__option-select"
              step="0.25"
              pattern="^\d*\.?\d*((25)|(50)|(5)|(75)|(0)|(00))?$"
              min="-5"
              max="5"
            />
          </div>
          <div css={styling.input}>
            <label htmlFor="customerRightCylinder">cylinder</label>
            <input
              onChange={formik.handleChange}
              required
              type="number"
              name="right_cylinder"
              value={formik.values.right_cylinder}
              id="customerRightCylinder"
              className="product-form__option-select"
              step="0.25"
              pattern="^\d*\.?\d*((25)|(50)|(5)|(75)|(0)|(00))?$"
              min="-4"
              max="0"
            />
          </div>
          <div css={styling.input}>
            <label htmlFor="customerRightAxis">axis</label>
            <input
              onChange={formik.handleChange}
              type="number"
              name="right_axis"
              value={formik.values.right_axis}
              id="customerRightAxis"
              className="product-form__option-select"
              min="0"
              max="180"
            />
          </div>
        </div>
      </div>

      <div css={styling.fullInput}>
        <label htmlFor="customerPupillaryDistance">{'pupillary distance (pd)'}</label>
        <input
          onChange={formik.handleChange}
          required
          type="number"
          step="0.25"
          name="p_d"
          value={formik.values.p_d}
          id="customerPupillaryDistance"
          className="product-form__option-select"
          min="0"
        />
        <button css={styling.button} type="submit" disabled={disableButton(formik.values)}>
          {hasPrescription ? 'Endre' : 'Legg til'}
        </button>
      </div>
    </form>
  );
}
